import { AlertTriangle, RefreshCw } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-red-200 bg-red-50 p-8 text-center">
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
        <AlertTriangle className="h-6 w-6 text-red-600" />
      </div>
      <h2 className="mb-1 text-lg font-semibold text-red-900">Something went wrong</h2>
      <p className="mb-4 max-w-md text-sm text-red-600">
        An unexpected error occurred. Please try again.
      </p>
      <Button onClick={resetErrorBoundary} variant="outline" className="gap-2 border-red-300 text-red-700 hover:bg-red-100">
        <RefreshCw className="h-4 w-4" />
        Try again
      </Button>
      {import.meta.env.DEV && (
        <details className="mt-4 w-full max-w-lg text-left">
          <summary className="cursor-pointer text-xs font-medium text-red-500">
            Technical details
          </summary>
          <pre className="mt-2 max-h-48 overflow-auto rounded-lg bg-red-950 p-3 text-xs text-red-200">
            {error.stack ?? error.message}
          </pre>
        </details>
      )}
    </div>
  )
}
